// Only themes are allowed to import scss files.
// eslint-disable-next-line import/no-unassigned-import
import '../../../../scss/themes/default/default.scss';

function MusterTheme() {
    return null;
}

export default MusterTheme;
